module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[107]228.1d044f6.woff2";